// Mock data for Sushant's Developer Portfolio

export const personalInfo = {
  name: "Sushant Kumar Yadav",
  title: "Application Developer",
  subtitle: "Security-Focused · Systems-Driven",
  tagline: "Building systems that work in the real world",
  description: "Computer Engineering Student specializing in full-stack development with a strong focus on security, backend systems, and Linux-based automation.",
  location: "Pune, Maharashtra, India",
  origin: "Dharan, Nepal",
  email: "sushantkumaryadav912@gmail.com",
  phone: "+91 7387321040",
  github: "https://github.com/sushantkumaryadav912",
  linkedin: "https://linkedin.com/in/sushantkumaryadav",
  experience: "2+ years"
};

export const skills = [
  {
    id: 1,
    category: "Frontend",
    icon: "Monitor",
    color: "cyan",
    items: [
      { name: "React.js", level: 90 },
      { name: "Next.js", level: 85 },
      { name: "React Native", level: 80 },
      { name: "TypeScript", level: 85 },
      { name: "Tailwind CSS", level: 90 }
    ]
  },
  {
    id: 2,
    category: "Backend",
    icon: "Server",
    color: "amber",
    items: [
      { name: "Node.js", level: 90 },
      { name: "Express.js", level: 90 },
      { name: "MongoDB", level: 85 },
      { name: "PostgreSQL", level: 80 },
      { name: "REST APIs", level: 95 }
    ]
  },
  {
    id: 3,
    category: "Security",
    icon: "Shield",
    color: "green",
    items: [
      { name: "JWT Authentication", level: 90 },
      { name: "RBAC", level: 85 },
      { name: "OTP Systems", level: 85 },
      { name: "Encryption", level: 80 },
      { name: "SIEM", level: 75 }
    ]
  },
  {
    id: 4,
    category: "Systems",
    icon: "Terminal",
    color: "neutral",
    items: [
      { name: "Linux", level: 85 },
      { name: "Docker", level: 80 },
      { name: "Git", level: 90 },
      { name: "Networking", level: 80 },
      { name: "Automation", level: 85 },
      { name: "AWS", level: 75 },
      { name: "GCP", level: 70 },
      { name: "Azure", level: 70 }
    ]
  }
];

export const projects = [
  {
    id: 1,
    title: "Orbis",
    subtitle: "Multi-Tenant Inventory Manager",
    description: "Security-focused inventory management system with role-based access control, JWT authentication, and multi-tenant architecture.",
    tags: ["React", "Node.js", "MongoDB", "JWT", "RBAC"],
    category: "Full-Stack",
    featured: true,
    status: "Completed",
    year: "2024",
    duration: "3 months",
    role: "Full-Stack Developer",
    problem: "Small to medium businesses need affordable, secure inventory management without vendor lock-in.",
    solution: "Built a multi-tenant SaaS platform with granular permissions, audit logging, and offline-first capabilities.",
    impact: "Reduced inventory tracking errors by 40% in pilot deployment. Supports 100+ concurrent users per tenant.",
    techStack: ["React.js", "Node.js", "Express", "MongoDB", "JWT", "Docker"],
    features: [
      "Multi-tenant architecture with data isolation",
      "Role-based access control (Admin, Manager, Staff)",
      "Real-time inventory updates",
      "Audit logging for compliance",
      "Export reports (PDF, CSV)",
      "OTP-based login"
    ],
    challenges: [
      {
        challenge: "Ensuring tenant data isolation",
        solution: "Implemented schema-level isolation with tenant-specific database connections and middleware validation."
      },
      {
        challenge: "Scaling concurrent user sessions",
        solution: "Used Redis for session management and implemented connection pooling."
      }
    ],
    github: "https://github.com/sushantkumaryadav912/orbis",
    demo: null
  },
  {
    id: 2,
    title: "GreenHouse",
    subtitle: "Smart Energy Management App",
    description: "Hackathon-winning mobile application for tracking and optimizing household energy consumption with real-time analytics.",
    tags: ["React Native", "Expo", "Firebase", "IoT"],
    category: "Mobile",
    featured: true,
    status: "Completed",
    year: "2024",
    duration: "48 hours (Hackathon)",
    role: "Mobile App Developer",
    problem: "Households lack visibility into energy consumption patterns, leading to waste and high bills.",
    solution: "Built a mobile app that connects to smart meters and provides actionable insights with AI-powered recommendations.",
    impact: "Won 1st place at GDGC Hackathon. Projected 15-20% energy savings for users.",
    techStack: ["React Native", "Expo", "Firebase", "Node.js", "Chart.js"],
    features: [
      "Real-time energy monitoring",
      "Historical usage analytics",
      "Device-level breakdown",
      "Cost estimation",
      "Push notifications for anomalies",
      "Goal setting and tracking"
    ],
    challenges: [
      {
        challenge: "48-hour deadline with full feature set",
        solution: "Prioritized MVP features, used Firebase for rapid backend setup, and focused on core energy tracking functionality."
      }
    ],
    github: "https://github.com/sushantkumaryadav912/greenhouse",
    demo: null
  },
  {
    id: 3,
    title: "Doodling",
    subtitle: "Secure Chat Application",
    description: "End-to-end encrypted chat application with self-destructing messages and zero-knowledge architecture.",
    tags: ["React", "Socket.io", "Node.js", "Encryption"],
    category: "Full-Stack",
    featured: true,
    status: "Completed",
    year: "2024",
    duration: "2 months",
    role: "Full-Stack Developer",
    problem: "Existing chat apps compromise privacy with server-side message storage and metadata leakage.",
    solution: "Built a zero-knowledge chat app where messages are encrypted client-side and stored ephemerally.",
    impact: "End-to-end encryption with forward secrecy. Messages auto-delete after read or time expiry.",
    techStack: ["React", "Socket.io", "Node.js", "MongoDB", "CryptoJS"],
    features: [
      "End-to-end encryption",
      "Self-destructing messages",
      "Screenshot detection (mobile)",
      "Zero-knowledge server architecture",
      "Real-time messaging with Socket.io",
      "User presence indicators"
    ],
    challenges: [
      {
        challenge: "Implementing forward secrecy",
        solution: "Used Diffie-Hellman key exchange with rotating session keys."
      }
    ],
    github: "https://github.com/sushantkumaryadav912/doodling",
    demo: null
  },
  {
    id: 4,
    title: "SIEM Log Analysis",
    subtitle: "Threat Detection System",
    description: "Real-time security information and event management system for analyzing logs and detecting anomalies.",
    tags: ["Python", "ELK Stack", "Machine Learning", "Security"],
    category: "Security",
    featured: false,
    status: "In Progress",
    year: "2024",
    duration: "Ongoing",
    role: "Security Engineer",
    problem: "Manual log analysis is time-consuming and misses real-time threats.",
    solution: "Building an automated SIEM system that aggregates logs, detects patterns, and alerts on suspicious activity.",
    impact: "Currently processing 10K+ logs per hour in test environment.",
    techStack: ["Python", "Elasticsearch", "Logstash", "Kibana", "Scikit-learn"],
    features: [
      "Log aggregation from multiple sources",
      "Real-time anomaly detection",
      "Custom alerting rules",
      "Dashboard for threat visualization",
      "Machine learning for pattern recognition"
    ],
    challenges: [],
    github: "https://github.com/sushantkumaryadav912/siem-analysis",
    demo: null
  },
  {
    id: 5,
    title: "Network Traffic Analysis",
    subtitle: "Intrusion Detection System",
    description: "Deep packet inspection tool for analyzing network traffic and identifying potential security threats.",
    tags: ["Python", "Wireshark", "Scapy", "Networking"],
    category: "Security",
    featured: false,
    status: "In Progress",
    year: "2024",
    duration: "Ongoing",
    role: "Network Security Analyst",
    problem: "Network intrusions often go undetected until significant damage occurs.",
    solution: "Building a tool that captures, analyzes, and flags suspicious network packets in real-time.",
    impact: "Detected simulated DDoS and port scanning attacks in lab environment.",
    techStack: ["Python", "Scapy", "Wireshark", "PostgreSQL"],
    features: [
      "Deep packet inspection",
      "Protocol analysis",
      "Anomaly detection",
      "Geolocation tracking",
      "Export PCAP files"
    ],
    challenges: [],
    github: "https://github.com/sushantkumaryadav912/network-ids",
    demo: null
  },
  {
    id: 6,
    title: "Password Manager",
    subtitle: "C++ Encrypted Vault",
    description: "Command-line password manager with AES-256 encryption and master password protection.",
    tags: ["C++", "Encryption", "CLI"],
    category: "Systems",
    featured: false,
    status: "Completed",
    year: "2023",
    duration: "1 month",
    role: "Systems Programmer",
    problem: "Cloud-based password managers expose credentials to third-party servers.",
    solution: "Built a local-first password manager with strong encryption and zero cloud dependency.",
    impact: "Personal use tool with 100% offline functionality and military-grade encryption.",
    techStack: ["C++", "OpenSSL", "SQLite"],
    features: [
      "AES-256 encryption",
      "Master password authentication",
      "Local SQLite storage",
      "Password generation",
      "CLI interface",
      "Clipboard integration"
    ],
    challenges: [],
    github: "https://github.com/sushantkumaryadav912/password-vault",
    demo: null
  }
];

export const experience = [
  {
    id: 1,
    role: "Mobile Application Developer Intern",
    company: "Olcademy",
    location: "Remote",
    duration: "Jun 2024 - Aug 2024",
    description: "Developed React Native mobile applications with focus on user authentication and real-time data synchronization.",
    achievements: [
      "Built OTP-based authentication system",
      "Implemented offline-first architecture",
      "Reduced app load time by 30%"
    ]
  },
  {
    id: 2,
    role: "Computer Engineering Student",
    company: "Symbiosis Institute of Technology",
    location: "Pune, India",
    duration: "2022 - Present",
    description: "Pursuing Bachelor's in Computer Engineering with focus on networking, security, and systems programming.",
    achievements: [
      "Member of CodeX SIT (Official Coding Club)",
      "Participated in GDGC & ACM hackathons",
      "GPA: 8.5/10"
    ]
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Understanding Multi-Tenant Architecture",
    excerpt: "A deep dive into designing secure multi-tenant systems with proper data isolation and scaling strategies.",
    date: "2024-11-15",
    readTime: "8 min read",
    category: "Backend",
    tags: ["Architecture", "Security", "Scaling"],
    author: "Sushant Kumar Yadav"
  },
  {
    id: 2,
    title: "Implementing JWT Authentication the Right Way",
    excerpt: "Common pitfalls in JWT implementation and how to build secure, scalable authentication systems.",
    date: "2024-10-22",
    readTime: "6 min read",
    category: "Security",
    tags: ["JWT", "Auth", "Node.js"],
    author: "Sushant Kumar Yadav"
  },
  {
    id: 3,
    title: "Building Offline-First Mobile Apps",
    excerpt: "Strategies for building React Native apps that work seamlessly with unreliable network connections.",
    date: "2024-09-10",
    readTime: "10 min read",
    category: "Mobile",
    tags: ["React Native", "Offline", "Architecture"],
    author: "Sushant Kumar Yadav"
  },
  {
    id: 4,
    title: "SIEM Basics: Log Analysis for Security",
    excerpt: "Introduction to Security Information and Event Management systems and practical threat detection.",
    date: "2024-08-05",
    readTime: "12 min read",
    category: "Security",
    tags: ["SIEM", "Logs", "Threat Detection"],
    author: "Sushant Kumar Yadav"
  },
  {
    id: 5,
    title: "Linux Automation with Bash Scripts",
    excerpt: "Automating repetitive tasks in Linux environments with practical bash scripting examples.",
    date: "2024-07-18",
    readTime: "7 min read",
    category: "Systems",
    tags: ["Linux", "Automation", "DevOps"],
    author: "Sushant Kumar Yadav"
  },
  {
    id: 6,
    title: "Network Traffic Analysis with Scapy",
    excerpt: "Using Python's Scapy library for deep packet inspection and intrusion detection.",
    date: "2024-06-30",
    readTime: "9 min read",
    category: "Networking",
    tags: ["Python", "Scapy", "Security"],
    author: "Sushant Kumar Yadav"
  }
];

export const philosophy = {
  statement: "I focus on building systems that actually work in the real world. Most of my learning comes from breaking things, fixing them, and understanding why they failed—especially in backend systems, Linux environments, networking, and security.",
  principles: [
    {
      title: "Understand How Data Flows",
      description: "Before writing code, map out how data moves through the system. Where does it come from? Where does it go? What transforms it?"
    },
    {
      title: "Understand Where Security Breaks",
      description: "Security isn't a feature—it's a constraint. Identify attack surfaces early and design defensively from the start."
    },
    {
      title: "Design for Failure, Not Just Success",
      description: "Systems fail. Networks drop. Databases timeout. Build with failure in mind: retries, fallbacks, graceful degradation."
    },
    {
      title: "Prefer Simple, Auditable Solutions",
      description: "Clever code is hard to debug. Simple, boring solutions are easier to understand, maintain, and trust."
    }
  ]
};
